import { render, staticRenderFns } from "./AuctionList.vue?vue&type=template&id=ff1860da&scoped=true"
import script from "./AuctionList.vue?vue&type=script&lang=js"
export * from "./AuctionList.vue?vue&type=script&lang=js"
import style0 from "./AuctionList.vue?vue&type=style&index=0&id=ff1860da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1860da",
  null
  
)

export default component.exports